import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Button, Popover,
} from 'reactstrap';

import Skeleton from 'react-loading-skeleton';
import FileCollections from '../Collections';

const FileCollectionsPopover = ({ file, fileCollections, loading }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Button
        id="FileCollectionsPopover"
        type="button"
        color="link"
        className="file-collections-popover-button"
        onClick={toggle}
        style={{ pointerEvents: fileCollections.length === 0 ? 'none' : 'auto' }}
      >
        {loading && <Skeleton style={{ width: 140 }} />}
        {(!loading && fileCollections.length === 0 && file.type === 'link') &&
          intl.formatMessage({ defaultMessage: `Link doesn't belong to any Collection` })}
        {(!loading && fileCollections.length === 0 && file.type !== 'link') &&
          intl.formatMessage({ defaultMessage: `File doesn't belong to any Collection` })}
        {(!loading && fileCollections.length > 0) && (
          <>
            <i className="fal fa-layer-group" />
            <span className="file-collections-popover-button-small">
              {fileCollections.length}
            </span>
            <span className="file-collections-popover-button-big">
              {
                intl.formatMessage(
                  { defaultMessage: 'Saved in {collectionsCount} {collectionsCount, plural, one {collection} other {collections}}' },
                  { collectionsCount: fileCollections.length },
                )
              }
            </span>
          </>
        )}
      </Button>
      <Popover
        placement="bottom"
        target="FileCollectionsPopover"
        className="file-collections-popover"
        isOpen={isOpen}
        toggle={toggle}
        trigger="legacy"
        hideArrow={true}
      >
        <FileCollections
          file={file}
          collections={fileCollections}
          loading={loading}
          personal={false}
        />
        <FileCollections
          file={file}
          collections={fileCollections}
          loading={loading}
          personal={true}
        />
      </Popover>
    </>
  );
};

FileCollectionsPopover.propTypes = {
  file: PropTypes.object.isRequired,
  fileCollections: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default FileCollectionsPopover;
